import Ticket from 'modules/Tickets/Chat/Ticket'
import Sagas from 'modules/Tickets/Chat/store/saga'
import Reducer from 'modules/Tickets/Chat/store/reducer'

export default Ticket

export { Sagas, Reducer }
